export const DEMO_BOARD_SLUG = "demo";
